import { NbMenuItem } from '@nebular/theme';
import { environment } from '@env/environment';


export let MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Alerts',
    icon: { icon: 'dashboard-icon', pack: 'lasgro-icons' },
    link: '/dashboard',
    data: {
      forRole: ['Manager', 'Company Admin'],
    },
  },
  {
    title: 'Messages',
    icon: { icon: 'envelope', pack: 'font-awesome' },
    link: '/dashboard/my-messages',
    data: {
      forRole: ['Manager', 'Company Admin'],
    },
  },
  {
    title: 'Analytics',
    icon: { icon: 'line-chart', pack: 'font-awesome' },
    link: '/reports',
    data: {
      forRole: ['Company Admin'],
      forCompanyType: 'customer',
    },
  },
  {
    title: 'My Organization',
    icon: { icon: 'company-icon', pack: 'lasgro-icons' },
    link: '/organization',
    data: {
      forRole: ['Manager', 'Company Admin'],
    },
  },
  {
    title: 'Organization Components',
    icon: { icon: 'company-icon', pack: 'lasgro-icons' },
    link: '/organization/organization-components',
    data: {
      forRole: ['Lasgro Admin'],
    },
  },
  {
    title: 'Organization Mails',
    icon: { icon: 'company-icon', pack: 'lasgro-icons' },
    link: '/organization/mails',
    data: {
      forRole: ['Company Admin'],
    },
  },
  // {
  //   title: 'Org. Workflows',
  //   icon: { icon: 'sitemap', pack: 'font-awesome' },
  //   link: '/workflows',
  //   data: {
  //     forRole: 'Lasgro Admin',
  //   },
  // },
  {
    title: 'Org. Settings',
    icon: { icon: 'cog', pack: 'font-awesome' },
    link: '/organization-settings',
    data: {
      forRole: ['Lasgro Admin'],
    },
  },

  {
    title: '',
    group: true,
  },

  {
    title: 'New Contract',
    icon: { icon: 'plus', pack: 'font-awesome' },
    link: '/purchase-order/create-simple',
    data: {
      forCompanyType: 'customer',
      forRole: ['Manager', 'Company Admin'],
    },
  },
  {
    title: 'Contract(s)',
    icon: { icon: 'pos-issued-icon', pack: 'lasgro-icons' },
    link: '/customers/work-commissioned',
    data: {
      forCompanyType: 'customer',
    },
  },
  {
    title: 'My Suppliers',
    icon: { icon: 'my-suppliers-icon', pack: 'lasgro-icons' },
    link: '/customers/my-suppliers',
    data: {
      forCompanyType: 'customer',
      forRole: ['Manager', 'Company Admin'],
    },
  },

  {
    title: '',
    group: true,
  },

  {
    title: 'Contract(s)',
    icon: { icon: 'download-icon', pack: 'lasgro-icons' },
    link: '/suppliers/work-in-progress',
    data: {
      forCompanyType: 'supplier',
    },
  },

  {
    title: '',
    group: true,
    data: {
      forCompanyType: 'supplier',
    },
  },

  {
    title: 'IT Help',
    icon: { icon: 'question', pack: 'font-awesome' },
    link: '/help/it-help',
  },
  {
    title: 'Training Guides',
    icon: { icon: 'info', pack: 'font-awesome' },
    link: '/help/training-guides',
  },

  {
    title: '',
    group: true,
  },

  {
    title: 'Log out',
    icon: { icon: 'sign-out', pack: 'font-awesome' },
    link: '/auth/logout',
  },
];
